import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { userLogOut } from '../../actions/app/app';
import { setSidebarItem } from '../../actions/sidebar/sidebar';
import { showModal } from '../../actions/modal/modal';
import { showEditUser } from '../../actions/mainview/mainview';
import { modalActions } from '../../helpers/constants';
import Helper from '../../helpers/helper';

const Accountitem = () => { 

  const dispatch = useDispatch(),
        appProps = useSelector(store => store.app),
        mainviewProps = useSelector(store => store.mainview),
        sidebarProps = useSelector(store => store.sidebar);

  const itemShown = sidebarProps.sidebarItem === 'Account',
        isAdmin = appProps.loggedInUser?.is_admin;

  const _showCreateAccountModal = () => {
    dispatch(showModal('Authentication'));
    
    dispatch({
      type: modalActions.SET_DEFAULT_AUTHENTICATION_FORM,
      payload: 'signUp'
    });
  }

  const _checkForSightingAdd = () => {

    if (mainviewProps.isChoosingLocation) return Helper.setNotification('info', 'Unable to continue', 'Please finish choosing a sighting location before doing anything else.', true);

    dispatch(setSidebarItem(sidebarProps.sidebarItem === 'Account' ? '' : 'Account'));
  }
  
  return (
    <>
      <span className={ `sidebar__item ${ itemShown ? 'sidebar__item--active' : '' }` } onClick={ () => _checkForSightingAdd() } title="Manage account">
        <i className="sidebar__icon far fa-user"></i>
        <span className="sidebar__text">
          {
            appProps.isUserAuthenticated ?
            (
              appProps.loggedInUser.user.first_name !== '' ?
                appProps.loggedInUser.user?.first_name :
                appProps.loggedInUser?.user?.email
            ) : 'Account'
          }
        </span>
      </span>
      <div className={ `sidebar__sub-nav ${ itemShown ? 'sidebar__sub-nav--show' : '' }` }>

        {
          appProps.isUserAuthenticated ?
          (
            <>
              <span className="sidebar__sub-nav-item" onClick={ () => dispatch(showEditUser(appProps.loggedInUser)) }>Edit my account</span>              
              {
                isAdmin &&
                <>
                  <span className="sidebar__sub-nav-item" onClick={ () => _showCreateAccountModal() }>Create new user</span>
                  <span className="sidebar__sub-nav-item" onClick={ () => dispatch(showModal('AccountManagement')) }>Manage users</span>
                  <span className="sidebar__sub-nav-item" onClick={ () => dispatch(showModal('VerifySightings')) }>Manage sightings</span>
                </>
              }
              
              <span className="sidebar__sub-nav-item" onClick={ () => dispatch(userLogOut()) }>Sign out</span>
            </>
          ) :
          (
            <span className="sidebar__sub-nav-item" onClick={ () => dispatch(showModal('Authentication')) }>Sign in</span>
          )
        }

      </div>
    </>
  );

}

export default Accountitem;